"use strict";

var LocalStorageAdapter = require("./LocalStorageAdapter");
module.exports = {
  LocalStorageAdapter: LocalStorageAdapter
};